import React from "react";
import { Navigate, useLocation, matchPath } from "react-router-dom";
import pageRoutes from "page_routes_copy"; // Standardized to your active registry module

const findActiveRoute = (routes, pathname) => {
  for (const route of routes) {
    if (route.route && matchPath({ path: route.route, end: true }, pathname)) {
      return route;
    }
    if (route.collapse) {
      const childMatch = findActiveRoute(route.collapse, pathname);
      if (childMatch) return childMatch;
    }
  }
  return null;
};

const PermissionGuard = ({ selectedOrg, userPermissions = [], children }) => {
  const { pathname } = useLocation();
  if (pathname === "/") return children;

  const currentRoute = findActiveRoute(pageRoutes, pathname);
  if (!currentRoute) return children;

  // 3. Evaluate Permissions
  const requiredToken = currentRoute.key;

  // console.log(currentRoute)
  // console.log(typeof currentRoute.exclusions == 'undefined', currentRoute?.exclusions?.indexOf(selectedOrg) < 0)
  // console.log(userPermissions)
  // console.log(requiredToken)

  const isAllowed = (!requiredToken || userPermissions.includes(requiredToken)) &&
    (typeof currentRoute.exclusions == 'undefined' || currentRoute?.exclusions?.indexOf(selectedOrg) < 0);

  if (!isAllowed) {
    console.warn(`Access Denied to ${pathname}. Missing permissions.`);
    // console.warn(`Access Denied to ${pathname}. Missing token: ${requiredToken}`);

    // Smart Fallback Extraction: Handle unique base folder mappings cleanly
    const baseSegment = pathname.split("/").filter(Boolean)[0];

    let parentModuleKey = baseSegment;

    // Explicit structural mappings to translate URL paths back to your real module permission names
    if (baseSegment === "campaigns") parentModuleKey = "campaign_manager";
    if (baseSegment === "operations") parentModuleKey = "stopmonitor"; // Stopmonitor owns operations configurations

    // Fallback Verification: Determine if they are allowed on the parent view list page
    const canAccessParentList = userPermissions.includes(parentModuleKey)// || userPermissions.includes("clearways"); // Permits map view redirects for clearways

    // Generate destination route: Fallback to base page if authorized, else step back to safety
    const fallbackDestination = canAccessParentList ? `/${baseSegment}` : "/";

    return <Navigate to={fallbackDestination} replace />;
  }

  return children;
};

export default PermissionGuard;